import './AutocompleteMenu-7f135c03.css';

var classes = {"SpinnerWrapper":"prc-Autocomplete-SpinnerWrapper-OvHpT","EmptyStateWrapper":"prc-Autocomplete-EmptyStateWrapper-tAx1w"};

export { classes as default };
